import * as ActionTypes from './actionTypes';

export const restoreOrdersGroupedManagement = () => ({
  'type': ActionTypes.RESTORE_ORDERS_GROUPED_MANAGEMENT,
});

export const editOrdersGroupedManagementFilter = (field, value) => ({
  'type': ActionTypes.EDIT_ORDERS_GROUPED_MANAGEMENT_FILTER,
  'payload': {field, value},
});
